import deriveShade from "@/utils/deriveShade";
import getTextColor from "@/utils/getTextColor";
import React, { useRef } from "react";

export interface EcommerceProduct {
  name: string;
  image: string;
  link: string;
  price: string;
  description?: string;
}

interface ProductCardProps {
  product: EcommerceProduct;
  chatConfig?: any;
  onBuyNow?: (product: EcommerceProduct) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  chatConfig,
  onBuyNow,
}) => {
  const isDark = chatConfig?.theme === "dark";
  const isProcessingRef = useRef(false);

  const handleBuyNow = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // Prevent double-click/duplicate calls
    if (isProcessingRef.current) {
      return;
    }

    isProcessingRef.current = true;

    if (onBuyNow) {
      onBuyNow(product);
    }

    // Reset after a short delay
    setTimeout(() => {
      isProcessingRef.current = false;
    }, 1000);
  };

  const handleViewProduct = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(product.link, "_blank");
  };

  return (
    <div
      className={`product-card relative flex w-[170px] flex-col overflow-hidden rounded-[12px] border !pt-[0px]`}
      style={{
        boxShadow: "rgba(149, 157, 165, 0.15) 0px 4px 16px",
        borderColor: "rgba(0, 0, 0, 0.08)",
        background: chatConfig.messageBoxBgColor,
      }}
    >
      <div
        className="flex h-auto w-auto cursor-pointer items-center justify-center overflow-hidden rounded-t-[8px]"
        style={{
          background: deriveShade(chatConfig.messageBoxBgColor, 0.1),
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(product.link, "_blank");
        }}
      >
        <img
          src={product.image}
          alt={product.name}
          className="h-auto w-auto object-cover transition-transform duration-200 hover:scale-105"
          onError={(e) => {
            (e.target as HTMLImageElement).src =
              'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23999"%3E%3Crect x="3" y="3" width="18" height="18" rx="2" ry="2"/%3E%3Ccircle cx="8.5" cy="8.5" r="1.5"/%3E%3Cpolyline points="21 15 16 10 5 21"/%3E%3C/svg%3E';
          }}
        />
      </div>

      <div className="flex w-full flex-col items-start justify-start gap-[4px] px-[5px] py-[12px] pt-[12px]">
        <a
          href={product.link}
          target="_blank"
          rel="noopener noreferrer"
          className={`line-clamp-2 w-full truncate text-left text-[14px] font-medium leading-[110%] hover:underline`}
          style={{
            fontFamily: chatConfig?.typography?.font?.fontFamily || "inherit",
            color: getTextColor(chatConfig.messageBoxBgColor),
          }}
        >
          {product.name}
        </a>

        {/* Price */}
        <span
          className={`w-full truncate text-[13px] !font-semibold leading-[110%]`}
          style={{
            fontFamily: chatConfig?.typography?.font?.fontFamily || "inherit",
            color: getTextColor(chatConfig?.chatBgColor),
          }}
        >
          {product.price}
        </span>

        {/* Action Buttons */}
        {/* <div className="flex gap-[8px] mt-auto pt-[6px]">
          <button
            onClick={handleBuyNow}
            className={`flex-1 px-[14px] py-[9px] rounded-[8px] text-[13px] font-medium transition-all duration-200 ${
              isDark
                ? 'bg-[#fb5f66] hover:bg-[#e54e55] text-white'
                : 'bg-[#fb5f66] hover:bg-[#e54e55] text-white'
            }`}
            style={{
              fontFamily: chatConfig?.typography?.font?.fontFamily || 'inherit',
            }}
          >
            Buy Now
          </button>
          <button
            onClick={handleViewProduct}
            className={`px-[14px] py-[9px] rounded-[8px] text-[13px] font-medium transition-all duration-200 ${
              isDark
                ? 'bg-[#444] hover:bg-[#555] text-white'
                : 'bg-[#f8f8f8] hover:bg-[#ededed] text-[#444]'
            }`}
            style={{
              fontFamily: chatConfig?.typography?.font?.fontFamily || 'inherit',
            }}
          >
            View
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default ProductCard;
